import MomentUtils from '@date-io/moment';
import { createMuiTheme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
import { Admin, Resource } from 'react-admin';
import { authProvider } from './api';
import multiDataProvider from './api/multiDataProvider';
import cs from './cs';
import customRoutes from './custom-routes';
import scheduleMealsReducer, { scheduleMeals } from './customer-order/reducer';
import { CustomerCreate } from './customers/CustomerCreate';
import { CustomerEdit } from './customers/CustomerEdit';
import { CustomerListV2 } from './customers/CustomerListV2';
import { Dashboard } from './dashboard';
import { Layout } from './layout';
import { MenuCreate } from './menus/MenuCreate';
import { MenuEdit } from './menus/MenuEdit';
import { MenuList } from './menus/MenuList';
import menusurvey from './menusurvey';
import orderSchedulesReducer, {
  orderSchedules,
} from './order-schedule/reducer';
import OrderCreate from './order/OrderCreate';
import OrderEdit from './order/OrderEdit';
import OrderItemCreate from './order/OrderItemCreate';
import OrderItemEdit from './order/OrderItemEdit';
import OrderList from './order/OrderList';
import { ReviewDataList } from './reviewdata';
import { ReviewDataCustomer } from './reviewdata-customer';
import { CustomerSettleList } from './settlement-customer';
import { SupplierSettleList } from './settlement-supplier';
import { SupplierCreate } from './suppliers/SupplierCreate';
import { SupplierEdit } from './suppliers/SupplierEdit';
import { SupplierList } from './suppliers/SupplierListV2';
import { SupplierCashReceiptList } from './settlement-cash-receipt';
import themeDev from './theme-dev.json';
import themeProd from './theme-prod.json';
import axios from 'axios';
import testReducer from './order-settlement/test.reducer';
import './common/css/react-admin.list.css';
import { CustomerTaxInvoiceList } from './settlement-customer-tax-invoice';

const isProd = !(
  process.env.NODE_ENV !== 'production' ||
  process.env.REACT_APP_ENV !== 'production'
);

const theme = createMuiTheme(isProd ? themeProd : themeDev);

// console.log(process.env.REACT_APP_ENV);
// console.log(process.env.REACT_APP_FCS_API_URL);
axios.defaults.baseURL = process.env.REACT_APP_FCS_API_URL;

const App = () => {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Admin
        authProvider={authProvider}
        dataProvider={multiDataProvider}
        customRoutes={customRoutes}
        customReducers={{
          [orderSchedules]: orderSchedulesReducer,
          [scheduleMeals]: scheduleMealsReducer,
          testReducerCommon: testReducer,
        }}
        layout={Layout}
        dashboard={Dashboard}
        theme={theme}
      >
        <Resource
          name='suppliers'
          options={{ label: '공급사관리' }}
          list={SupplierList}
          edit={SupplierEdit}
          create={SupplierCreate}
        />
        {/* <Resource name="customers" options={{ label: '고객사관리' }} list={CustomerList} edit={CustomerEdit} create={CustomerCreate} /> */}
        <Resource
          name='customers'
          options={{ label: '고객사관리' }}
          list={CustomerListV2}
          edit={CustomerEdit}
          create={CustomerCreate}
        />
        {/* <Resource
          name='order-items'
          edit={OrderItemEdit}
          create={OrderItemCreate}
        /> */}
        {/* <Resource
          name='order'
          options={{ label: '주문관리' }}
          list={OrderList}
          edit={OrderEdit}
          create={OrderCreate}
        />
        <Resource name='order/settlement' /> */}
        <Resource
          name='menus'
          options={{ label: '메뉴관리' }}
          list={MenuList}
          edit={MenuEdit}
          create={MenuCreate}
        />
        <Resource
          name='usermenus/reviews'
          options={{ label: '리뷰데이터' }}
          list={ReviewDataList}
        />
        <Resource
          name='files'
          options={{ label: '리뷰데이터-기업별' }}
          list={ReviewDataCustomer}
        />
        <Resource name='cs' options={{ label: 'CS 관리' }} {...cs} />
        <Resource
          name='sp-stlist'
          options={{ label: '공급자 정산' }}
          list={SupplierSettleList}
        />
        <Resource
          name='sp-crlist'
          options={{ label: '공급자 현금영수증' }}
          list={SupplierCashReceiptList}
        />
        <Resource
          name='cm-stlist'
          options={{ label: '고객사 정산' }}
          list={CustomerSettleList}
        />
        <Resource
          name='cm-tilist'
          options={{ label: '고객사 세금계산서' }}
          list={CustomerTaxInvoiceList}
        />
        {/* <Resource name="cm-confirm" options={{ label: '26.신청인원확인' }} list={CustomerConfirm} /> */}
        {/* <Resource name="verified" options={{ label: '27.큐레이션 데이터' }}list={MonthlyRatingList} />
      <Resource name="monthly" options={{ label: '28.큐레이션 데이터-1' }}list={MonthlyBestList} />
      <Resource name="monthly1" options={{ label: '29.큐레이션 데이터-2' }}list={MonthlyUserList} />
      <Resource name="webusers" options={{ label: '31.직원관리' }} list={WebUserList} edit={WebUserEdit} /> */}
        <Resource
          name='menusurveys'
          options={{ label: '이건어떄요' }}
          {...menusurvey}
        />
        {/* <Resource name="delivery" options={{ label: '10.배송그룹설정' }} list={CustomerDelivery} /> */}
        <Resource name='supplierServiceTypes' />
        <Resource name='menuCategoryLv1s' />
        <Resource name='menuCategoryLv2s' />
        <Resource name='commonCodes' />
        <Resource name='uploadedFiles' />
        <Resource name='customerMenuRatios' />
        <Resource name='Banks' />
      </Admin>
    </MuiPickersUtilsProvider>
  );
};

export default App;
